import React, { useLayoutEffect } from 'react';
import { Poppins, Spacer } from 'src/common';
import Button from 'src/components/form/Button';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './Guard.styles';

interface GuardProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  modalComponent: JSX.Element;
  isDirty: boolean;
  portalTarget?: string;
}

export const Guard: React.FC<GuardProps> = ({ onClose, onCancel, modalComponent, isOpen, isDirty, portalTarget }) => {
  // Hook must run unconditionally (it used to sit below the early return, which
  // breaks hook ordering when isOpen toggles); the isOpen guard keeps it a no-op.
  useLayoutEffect(() => {
    if (isOpen && !isDirty) {
      onClose();
    }
  }, [isDirty, isOpen]);

  if (!isOpen) return modalComponent;

  return (
    <S.StyledModal
      {...(portalTarget ? { parentSelector: () => document.getElementById(portalTarget)! } : {})}
      onRequestClose={onCancel}
      isOpen
      disableAnalytics
    >
      <Poppins className="text-center" px={28} weight={600} color="prussianBlue">
        Close without saving?
      </Poppins>
      <Spacer $px={18} />
      <Poppins className="text-center subtitle" px={18} color="prussianBlue">
        Closing this page will erase all the recent changes made.
      </Poppins>
      <Spacer $px={35} />
      <div className="buttons">
        <Button
          secondary
          onClick={() => {
            onCancel();
            mpEvent(MPEvents.ButtonClick, {
              button: 'Cancel',
              modal: 'Guard',
            });
          }}
        >
          CANCEL
        </Button>
        <Button
          primary
          onClick={() => {
            onClose();
            mpEvent(MPEvents.ButtonClick, {
              button: 'Close',
              modal: 'Guard',
            });
          }}
        >
          CLOSE
        </Button>
      </div>
    </S.StyledModal>
  );
};
